import {Property} from "csstype";

export type ColorScheme = {
    Key: string;
    RoleColor: Property.Color;
    GroupColor: Property.Color;
    FunnelColor: Property.Color;
}
export const DEFAULT_COLOR_SCHEME_KEY = 'default_a';
export const ColorSchemeList: ColorScheme[] = [
    {
        // 001
        Key: DEFAULT_COLOR_SCHEME_KEY,
        RoleColor: '#6B5C7B',
        GroupColor: '#C06C83',
        FunnelColor: '#F4A98C',
    },
    {
        // 002
        Key: 'default_b',
        RoleColor: '#5EBFD0',
        GroupColor: '#FF6D70',
        FunnelColor: '#FFCC66',
    },
    {
        // 003
        Key: 'default_d',
        RoleColor: '#5F52A0',
        GroupColor: '#C81F43',
        FunnelColor: '#FF9E00',
    },
    {
        // 004
        Key: 'default_e',
        RoleColor: '#001C58',
        GroupColor: '#0068B7',
        FunnelColor: '#B2DFDB',
    },
    {
        // 005
        Key: 'default_f',
        RoleColor: '#1E3D4E',
        GroupColor: '#13B5B1',
        FunnelColor: '#FFF799',
    },
    {
        // 006
        Key: 'default_g',
        RoleColor: '#005982',
        GroupColor: '#13B5B1',
        FunnelColor: '#B8D68A',
    },
    {
        // 007
        Key: 'default_h',
        RoleColor: '#362E2B',
        GroupColor: '#7E0043',
        FunnelColor: '#F8CB4B',
    },
    {
        // 008
        Key: 'default_i',
        RoleColor: '#7C5193',
        GroupColor: '#8DB141',
        FunnelColor: '#F19149',
    },
];

function findDefaultScheme(): ColorScheme {
    const default_scheme = findColorSchemeOrNull(DEFAULT_COLOR_SCHEME_KEY);
    if (default_scheme === null) {
        throw new Error("no default color scheme");
    }

    return default_scheme;
}

export function findColorSchemeOrNull(color_scheme_key: string): ColorScheme | null {

    const scheme = ColorSchemeList.find(scheme => scheme.Key === color_scheme_key);
    if (scheme === undefined) {
        return null;
    }

    return scheme;
}

export function findColorSchemeOrDefault(color_scheme_key: string): ColorScheme {
    return findColorSchemeOrNull(color_scheme_key) || findDefaultScheme();
}
